export default [
    {
        tenantId: '612',
        userId: '95508',
        issueId: '27466',
        id: '12502',
        uuid: '0ba3fd0c-84c4-4cf5-b13e-f6296905e8e2',
        color: '#ff5722',
        startPage: 2,
        startPageStartOffset: 983,
        startPageLength: 135,
        endPage: 2,
        endPageLength: null,
        totalLength: 135,
        totalText:
            'o pasado se aprobó la reforma de  la  Caja  Militar,  el  diputado  frenteamplista Alfredo Asti expli-có a la diaria que esta no tendrá',
        startChar: null,
    },
    {
        tenantId: '612',
        userId: '95508',
        issueId: '27466',
        id: '12504',
        uuid: '8e864722-2e94-4a74-bc59-649d63c3278b',
        color: '#03a9f4',
        startPage: 3,
        startPageStartOffset: 3883,
        startPageLength: 389,
        endPage: 3,
        endPageLength: null,
        totalLength: 389,
        totalText:
            'Además,  en  caso  de  “emergencia  meteorológica  u  otras  situaciones  imprevistas que afecten la limpieza de la ciudad” la comuna podrá convocar a “otros sectores [...] relacionados con las actividades de limpieza a cubrir servicios mínimos en caso de parali-zación de actividades”. La propuesta fue  rechazada  por  la  presidenta  de  ADEOM, Valeria Ripoll, en una con-ferencia  de',
        startChar: null,
    },
    {
        tenantId: '612',
        userId: '95508',
        issueId: '27466',
        id: '12505',
        uuid: '0dbd6720-d369-4716-8f56-391bc909dca2',
        color: '#ff4081',
        startPage: 3,
        startPageStartOffset: 2729,
        startPageLength: 474,
        endPage: 3,
        endPageLength: null,
        totalLength: 474,
        totalText:
            'Sobre decretar la esencialidad del servicio  de  limpieza,  el  presidente  de  la  central  sindical  sostuvo  que  “para el sindicato la mejor lógica es que la esencialidad no esté colocada arriba  de  la  mesa,  sino  que  haya  una autorregulación”, y así opina el PIT-CNT para cada uno de los sin-dicatos. Explicó que las medidas de paro no son un motivo para decretar la  esencialidad  del  servicio  y  que  tampoco depende de la popularidad de la medida sindical. “¿',
        startChar: null,
    },
    {
        tenantId: '612',
        userId: '95508',
        issueId: '27466',
        id: '12506',
        uuid: '25a0ffcd-ac34-4455-bca9-dc0a7d9522cb',
        color: '#ff4081',
        startPage: 4,
        startPageStartOffset: 4533,
        startPageLength: 481,
        endPage: 4,
        endPageLength: null,
        totalLength: 481,
        totalText:
            'El  sábado  de  madrugada  el  ex  diputado del FA y actual diri-gente  del  PN  Gonzalo  Mujica  fue detenido por la Policía en un control de tránsito rutinario en el balneario La Paloma, en el departamento de Rocha. La espirometría arrojó como resul-tado  0,41  gramos  de  alcohol  por litro de sangre, por lo que se le retiró la libreta de condu-cir. Mujica explicó que volvía de  una  reunión  con  amigos  en la que había tomado vino, informó Subrayado.Integrantes  del  Hono',
        startChar: null,
    },
    {
        tenantId: '612',
        userId: '95508',
        issueId: '27466',
        id: '12508',
        uuid: '15a7b5a7-708f-4aa3-b61f-48d0bdfc9477',
        color: '#ff5722',
        startPage: 5,
        startPageStartOffset: 2638,
        startPageLength: 824,
        endPage: 5,
        endPageLength: null,
        totalLength: 824,
        totalText:
            '“La verdadera opción no es entre el  diálogo  y  la  violencia,  como  se  plantea,  sino  entre  el  diálogo  y  la  presión  internacional  para  que  se  haga una convocatoria a elecciones libres,  con  todas  las  garantías,  en  un  plazo  más  o  menos  inmediato.  Mientras  tanto,  hay  que  reconocer  al  presidente  de  la  Asamblea  Na-cional  de  Venezuela  [Juan  Guaidó]  como  presidente  interino  y  como  responsable  de  hacer  ese  llamado  a elecciones, que es la posición que han  tomado  la  mayor  parte  de  los  países  de  América  Latina,  Estados  Unidos y Canadá, y los principales países  de  Europa”,  dijo  Talvi.  Por  último,  señaló  que  tener  la  misma  postura que países como Siria, Irán, Nicaragua, Cuba, China y Rusia deja a Uruguay “del lado equivocado de l a   e c u a c i ó n”.',
        startChar: null,
    },
    {
        tenantId: '612',
        userId: '95508',
        issueId: '27466',
        id: '12509',
        uuid: 'c86002ee-2269-4d2a-98fc-0d8f7b4832c3',
        color: '#ff4081',
        startPage: 8,
        startPageStartOffset: 1429,
        startPageLength: 59,
        endPage: 8,
        endPageLength: null,
        totalLength: 59,
        totalText: 'Querer trabajar es el primer paso para salir del Vilardebó”',
        startChar: null,
    },
    {
        tenantId: '612',
        userId: '95508',
        issueId: '27466',
        id: '12510',
        uuid: '0d79ac0c-0c3a-4f2d-9517-3b7ed83f5436',
        color: '#ff4081',
        startPage: 14,
        startPageStartOffset: 13,
        startPageLength: 93,
        endPage: 14,
        endPageLength: null,
        totalLength: 93,
        totalText: 'Maduro rechazó “ultimátum” de la UE para convocar elecciones y se mostró abierto al diálogo',
        startChar: null,
    },
];
